import React, { useState, useEffect } from "react";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { MainMessage, SubMessage } from "./styles";

const AlertWrapper = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={4} ref={ref} variant="outlined" {...props} />;
});

const Alert = (props) => {

  const [toastSettings, setToastSettings] = useState({
    open: false,
    message: "",
    severity: "error",
    displaySupportLink: false,
  });

  useEffect(() => {
    
    const { message, error, displaySupportLink} = props;
    if (message) {
      displayMessage(message, false);
    } else if (error) {
      displayError(error, displaySupportLink);
    }
  }, [props]);

  const displayMessage = (message, displaySupportLink) => {
    setToastSettings({
      ...toastSettings,
      severity: "info",
      open: true,
      message,
      displaySupportLink,
    });
  };

  const displayError = (message, displaySupportLink) => {
    setToastSettings({
      ...toastSettings,
      severity: "error",
      open: true,
      message,
      displaySupportLink,
    });
  };

  const handleToastClose = () => {
    const { onAlerted = () => {} } = props;

    setToastSettings({
      ...toastSettings,
      open: false,
      message: "",
      displaySupportLink: false,
    });

    onAlerted();
  };

  const { open, message, severity, displaySupportLink } = toastSettings;

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      autoHideDuration={6000}
      onClose={handleToastClose}
      sx={{ backgroundColor: "#FDEFF3", borderRadius: "4px" }}
    >
      <AlertWrapper
        onClose={handleToastClose}
        severity={severity}
        sx={{ width: "100%" }}
      >
        <MainMessage>{message}</MainMessage>
        {displaySupportLink && <SubMessage>
          Please submit your request to{" "}
          <a
            href="https://jll.service-now.com/sp?id=sc_cat_item&sys_id=bc5d72051bbcf8903a13fee3cc4bcb93&sysparm_category=e89e97981bd47490831d99b51a4bcb31"
            target="_blank"
            rel="noopener noreferrer"
          >
            TM Essentials Support
          </a>
        </SubMessage>}
      </AlertWrapper>
    </Snackbar>
  );
};

export default Alert;
